import { render, staticRenderFns } from "./LiabilityOtherFull.vue?vue&type=template&id=f8fded2c"
import script from "./LiabilityOtherFull.vue?vue&type=script&lang=js"
export * from "./LiabilityOtherFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports